<template>
    <div>
        <div id="header_bg">

		<div id="header_wrap">

			<div id="header_title">
            	<div id="header_logo"></div>
            </div>

		</div>

	</div>

	<!--내용시작-->

	<div id="content_warp">


		<form name="mailForm" id="mailForm" @submit.prevent="sendEmail">

        	<input type="hidden" name="_subject" value="TACHYON 제품 도입 문의가 도착하였습니다. (en-US)" style="display:none;" />

			<div class="td_box_left">
                <div>

                    <div class="td_left"><img src="@/assets/img/email_popup_img/nene_icon.png" border="0" hspace="5"> Company</div>
                </div>

                <div>
                    <div class="td_right"><input type="text" name="회사명" id="textfield" maxlength="20" v-model="company"/></div>
                </div>
			</div>

			<div class="td_box_right">
                <div>
                    <div class="td_left"><img src="@/assets/img/email_popup_img/nene_icon.png" border="0" hspace="5"> Name</div>

                </div>

                <div>

                    <div class="td_right"><input type="text" name="담당자명" id="textfield" maxlength="10" v-model="name"/></div>

                </div>
			</div>

			<div class="td_box_left">
                <div>

                    <div class="td_left"><img src="@/assets/img/email_popup_img/nene_icon.png" border="0" hspace="5"> Phone</div>

                </div>

                <div>

                    <div class="td_right"><input type="tel" name="연락처" id="textfield" maxlength="13"  onKeyPress="return numkeyCheck(event)" v-model="tel"/></div>

                </div>
    		</div>

            <div class="td_box_right">
                <div>

                    <div class="td_left"><img src="@/assets/img/email_popup_img/nene_icon.png" border="0" hspace="5"> E-mail</div>

                </div>

                <div>

                    <div class="td_right"><input type="email" name="이메일" id="textfield" maxlength="40" v-model="email"/></div>

                </div>
    		</div>

    		<div class="td_box_left">
                <div>

                    <div class="td_left"><img src="@/assets/img/email_popup_img/nene_icon.png" border="0" hspace="5"> Type</div>

                </div>


            	<div>

                    <div class="td_right">

                        <select name="구분" class="select1" size=1 v-model="sectionNo" @change="onChangeSection($event)">
                            <option v-for="s in sections" :key="s.no" :value="s.no">{{s.title}}</option>
                        </select>

                    </div>
                </div>

			</div>

            <div class="td_box_right">
                <div>

                    <div class="td_left"><img src="@/assets/img/email_popup_img/nene_icon.png" border="0" hspace="5"> Product</div>

                </div>

                <div>
                    <div class="td_right">
                        <select name="제품명" class="select2" size=1 v-model="selectedProduct">
                            <option v-for="p in products" :key="p.no" :value="p.title">{{p.title}}</option>
                        </select>

                        </div>

                </div>
			</div>


			<div class="td_box_center">
                    <div>
                        <div class="td_left"><img src="@/assets/img/email_popup_img/nene_icon.png" border="0" hspace="5"> Inquiry</div>
                    </div>

                    <div>
                        <div colspan="3" class="td_right"><textarea name="문의사항" rows="5" id="textarea_pro" v-model="inquiry"></textarea></div>
                    </div>


			</div>




<!--확인버튼-->
<div id="sub_bg">
	<div id="sub_wrap">
		<button id="sub_title" type="submit" v-if="showSubmit">Send</button>

	</div>
</div>

<!--확인버튼-->
<div id="sub_bg">
    <div id="sub_wrap">
        <h3 id="sending" v-if="sending">Sending . . .</h3>
    </div>
</div>


<input type="hidden" name="_next" value="/en/thankyou"/>
<input type="hidden" name="_language" value="en" />


</form>

</div>
    </div>
</template>
<script>
    import MailProduct from '@/shared/mail-product-en'

    export default {
        data: () => {
            return {
                products: [],
                sections: [],

                popupname: [],
                sectionNo: "0",
                productNo: "0",
                selectedSection: "기타",
                selectedProduct: "기타",
                agree: false,

                company: "",
                name: "",
                tel: "",
                email: "",
                inquiry: "",

                showSubmit: true,
                sending: false,
            }
        },
        created: function() {
            this.popupname = this.$route.params.popupname.split('_');
            this.sectionNo = this.popupname[0];
            this.productNo = this.popupname[1];
        },
        mounted: function() {
            this.bindProductList();
        },
        methods: {
            onChangeSection(event) {
                this.sectionNo = event.target.value;
                this.productNo = 0;
                this.sections.forEach((value) => {
                    this.setSection(value);
                })
            },
            bindProductList() {
                const items = new MailProduct().items;
                items.forEach((value) => {
                    this.sections.push(value);
                    this.setSection(value);
                });
            },
            setSection(section) {
                if(this.sectionNo == section.no) {
                    this.selectedSection = section.title;
                    this.setProduct(section.products);
                }
            },
            setProduct(products) {
                this.products = [];
                products.forEach((value) => {
                    this.products.push(value);
                    if(this.productNo == value.no) {
                        this.selectedProduct = value.title;
                    }
                })
            },
            sendEmail: function() {
                this.showSubmit = false;
                this.sending = true;

                let form = {
                    lang:'en',
                    company: this.company,
                    name: this.name,
                    tel: this.tel,
                    email: this.email,
                    section: this.selectedSection,
                    product: this.selectedProduct,
                    inquiry: this.inquiry,
                }

                // console.log(form);
                this.submitToMail(form);
            },
            submitToMail(form) {
                this.$http.post('/email/', null, {
                params : form}).then( res => {
                console.log(res.data);
                if(res.data.result == 'SUCCESS') {
                    this.$router.replace('/en/thankyou');
                }
                }).catch((error) => {
                console.log(error);
                }).finally(() => {
                // console.log("finally");
                })
            }
        },
    }
</script>
<style scoped>
    @import '../../../assets/css/mail_form_v10.css';
</style>